import React, { useState } from "react";
import PropTypes from "prop-types";
import ForgotPasswordLink from "./ForgotPasswordLink";
import ForgotPasswordSuccess from "./ForgotPasswordSuccess";
import AppVersion from "../common/AppVersion";

const ForgotPassword = ({
  setIsForgotPassword,
  initialUsername = "",
  passwordResetRequiredNotice = false,
}) => {
  const [isLinkSent, setIsLinkSet] = useState(false);
  return (
    <>
      {isLinkSent ? (
        <ForgotPasswordSuccess setIsForgotPassword={setIsForgotPassword} />
      ) : (
        <ForgotPasswordLink
          setIsForgotPassword={setIsForgotPassword}
          setIsLinkSet={setIsLinkSet}
          initialUsername={initialUsername}
          passwordResetRequiredNotice={passwordResetRequiredNotice}
        />
      )}
      <AppVersion />
    </>
  );
};

ForgotPassword.defaultProps = {
  setIsForgotPassword: () => {},
  initialUsername: "",
  passwordResetRequiredNotice: false,
};

ForgotPassword.propTypes = {
  setIsForgotPassword: PropTypes.func,
  initialUsername: PropTypes.string,
  passwordResetRequiredNotice: PropTypes.bool,
};

export default ForgotPassword;
